import React from "react";
import PropTypes from "prop-types";
import { resetElementCounters } from "../hooks/useUniqueId";

export const SSRContext = ({ children }) => {
  return resetElementCounters(() => <>{children}</>);
};

SSRContext.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

SSRContext.displayName = "SSRContext";

export default SSRContext;
